import React from 'react';
import InputByType from './parts/InputByTypeV2';
import GuaranteeValidationSummary from './parts/GuaranteeValidationSummary';
import { years } from '../../../common/constants';
import { building_type, evaluateConditions } from '../utils';

function TechnicalDataStep({
  errors,
  isValid,
  register,
  setValue,
  control,
  watch,
}) {
  const stepInputs = [
    {
      name: 'technical_location_data.annoc_value',
      label: 'Anno di costruzione immobile',
      placeholder: '-Anno di costruzione immobile-',
      type: 'select',
      options: years,
      className: 'col-12 col-md-12',
    },
    {
      name: 'technical_location_data.tpab_value',
      label: 'Tipo Fabbricato',
      placeholder: '-Tipo Fabbricato-',
      type: 'select',
      options: building_type,
      className: 'col-12 col-md-12',
    },
    {
      name: 'property_value',
      label: 'Valore Immobile',
      placeholder: '-Valore Immobile-',
      type: 'price',
      className: 'col-12 col-md-12',
    },
    {
      name: 'coverages',
      label: '',
      placeholder: '',
      type: 'nobis_coverages',
      condition: [
        { type: 'neq', field: 'technical_location_data.tpab_value', value: '' },
      ],
    },
  ];

  const coveragesVisible = evaluateConditions(
    [{ type: 'neq', field: 'technical_location_data.tpab_value', value: '' }],
    watch,
  );

  return (
    <div className="row mt-4">
      {stepInputs.map((input) => evaluateConditions(input.condition, watch) && (
        <div className={input.className} key={input.name}>
          <InputByType
            input={input}
            register={register}
            errors={errors}
            isValid={isValid}
            setValue={setValue}
            control={control}
            watch={watch}
            formData={watch()}
          />
        </div>
      ))}
      {coveragesVisible && <GuaranteeValidationSummary formData={watch()} />}
    </div>
  );
}

export default TechnicalDataStep;
